import { TranscriptionMode } from 'domain/event';
import i18n from 'i18n';

export const DEFAULT_NATTERING_DURATION = 10;

export const NATTERING_DURATION_OPTIONS = [2, 3, 5, 7, DEFAULT_NATTERING_DURATION, 15, 20, 30] as const;

export const TranscriptionOptions = Object.values(TranscriptionMode).map((mode) => ({
  label: i18n.t(`event:transcription.${mode}.label`),
  value: mode,
  description: i18n.t(`event:transcription.${mode}.description`),
}));
